export default {"src":"/_next/static/media/off-road.553eb0f5.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};